import { Icon, IconButton, Tooltip } from '@/ui';

interface OpsSessionActionButtonsProps {
  context: string;
  pending: boolean;
  onCancel?: (target: HTMLElement) => void;
  onReschedule?: (target: HTMLElement) => void;
}

// MEN-5338: Figma's Ops Reschedule / Cancel icon pair, matching the member
// session list's MemberSessionActionButtons.
const OpsSessionActionButtons = ({
  context,
  pending,
  onCancel,
  onReschedule,
}: OpsSessionActionButtonsProps) => (
  <div className="flex shrink-0 items-center gap-2">
    {onReschedule && (
      <Tooltip title="Reschedule">
        <span className="inline-flex rounded ring-1 ring-inset ring-cement-300">
          <IconButton
            aria-label={`Reschedule ${context}`}
            className="!rounded"
            color="secondary"
            disabled={pending}
            onClick={(event) => onReschedule(event.currentTarget)}
          >
            <Icon>edit_calendar</Icon>
          </IconButton>
        </span>
      </Tooltip>
    )}
    {onCancel && (
      <Tooltip title="Cancel">
        <span className="inline-flex rounded ring-1 ring-inset ring-cement-300">
          <IconButton
            aria-label={`Cancel ${context}`}
            className="!rounded"
            color="secondary"
            disabled={pending}
            onClick={(event) => onCancel(event.currentTarget)}
          >
            <Icon>trash</Icon>
          </IconButton>
        </span>
      </Tooltip>
    )}
  </div>
);

export default OpsSessionActionButtons;
